import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import {
  GetMessages,
  selectMessages,
} from "../../../features/messages/messageSlice";
import MessageItem from "./MessageItem";

const messages = [
  {
    id: 1,
    name: "Anand Mahindra",
    designation: "Chairman Mahindra Group",
    photo: "https://digitalcrown.in/demo/eg/images/leader1.png",
    message:
      "Ethical behaviour is the bedrock of our Core Values and is a part of our DNA. It is the responsibility " +
      "of each one of us to practice these behaviours and to help bring to light breaches of these values.",
  },
];

const MobLeadersMessages = ({ messagesList }: { messagesList: any }) => {
  // const messagesList = useAppSelector(selectMessages);
  // const dispatch = useAppDispatch();

  // useEffect(() => {
  //   async function fetchMessages() {
  //     let sample = await dispatch(GetMessages());
  //   }
  //   fetchMessages();
  // }, []);
  const messageArrayData = messagesList?.slice(0, 3);
  const editMessagelist: any = messageArrayData;
  return (
    <>
      <Row>
        <Col sm={12} style={{ padding: 0 }}>
          <div className="b_shadow" style={{ backgroundColor: "#fff" }}>
            <h4
              style={{
                // fontFamily: "Saira",
                fontSize: "16px",
                fontWeight: 500,
                padding: "20px",
              }}
            >
              Message from Mahindra leaders
            </h4>
            <MessageItem editMessagelist={editMessagelist} />
            {/* {editMessagelist?.map((item: { item: any }) => {
              return <MessageItem/>;
            })} */}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default MobLeadersMessages;
